export function getBookingAsEvents(allBookings) {
	let calendarEvents = [];
	for (let i = 0; i < allBookings.length; i++) {
		let eventObject_pass = {
			id: i + 1,
			title: allBookings[i].reserverName,
			start: allBookings[i].startTime,
			end: allBookings[i].endTime,
			className: "",
			extendedProps: {
				bookingId: allBookings[i].id,
				type: allBookings[i].bookingType,
				status: allBookings[i].status,
				reserverName: allBookings[i].reserverName,
				reserverEmail: allBookings[i].reserverEmail,
				reserverTelephone: allBookings[i].reserverTelephone,
				numOfPacks: allBookings[i].numOfPacks,
				subPackage: allBookings[i].subPackage,
				extras: allBookings[i].extras,
				totalPrice: allBookings[i].totalPrice,
				bookingTitle: allBookings[i].reserverName + " - ",
				startTime: allBookings[i].startTime,
				endTime: allBookings[i].endTime,
				bookingNote: allBookings[i].bookingNote,
				paymentMethod: allBookings[i].paymentMethod,
				paymentId: allBookings[i].paymentId,
				bookingValid: true,
				bookingPassed: false,
			},
		};

		var currentTime = new Date();
		if (eventObject_pass.end < currentTime.toISOString()) {
			eventObject_pass.className = "bg-light text-dark";
			eventObject_pass.extendedProps.bookingValid = false;
			eventObject_pass.extendedProps.bookingPassed = true;
		} else {
			if (
				eventObject_pass.extendedProps.type === "GENERAL" &&
				eventObject_pass.extendedProps.status === "PENDING"
			) {
				eventObject_pass.className = "bg-warning text-dark";
			} else if (
				eventObject_pass.extendedProps.type === "GENERAL" &&
				eventObject_pass.extendedProps.status === "CONFIRMED"
			) {
				eventObject_pass.className = "bg-success text-dark";
			} else if (
				eventObject_pass.extendedProps.type === "GENERAL" &&
				eventObject_pass.extendedProps.status === "CANCELLED"
			) {
				eventObject_pass.className = "bg-danger text-dark";
			} else if (eventObject_pass.extendedProps.type === "OUT_OF_SERVICE") {
				eventObject_pass.className = "bg-dark text-white";
			} else if (eventObject_pass.extendedProps.type === "LOGN") {
				eventObject_pass.className = "bg-info text-dark";
			}
		}

		calendarEvents.push(eventObject_pass);
	}

	return calendarEvents;
}

export class BookingType {
	static GENERAL = "GENERAL";
	static OUT_OF_SERVICE = "OUT_OF_SERVICE";
	static LONG = "LONG";
}
